export default __webpack_public_path__ + "images/logoPerricone.1d461c0756ab030a1d571ba9491442c9.svg"